import { SET_HAS_MORE } from 'root/src/client/logic/list/actionIds'

import { listStoreLenses } from 'root/src/client/logic/list/lenses'

const { setHasMore } = listStoreLenses

export const setHasMoreFunc = (state, { hasMore, moduleId }) => setHasMore(moduleId, hasMore, state)

export default {
	[SET_HAS_MORE]: setHasMoreFunc,
}
